import { Component, ElementRef, Inject, OnDestroy, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { CommonExternalModule } from '../../common/common-external-module';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductOrderSummaryServiceService } from '../../services/product-order-summary-service.service';
import { throwError } from 'rxjs';
import fileSaver from "file-saver";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-invoice-preview',
  standalone: true,
  imports: [CommonExternalModule],
  templateUrl: './invoice-preview.component.html',
  styleUrl: './invoice-preview.component.css'
})
export class InvoicePreviewComponent implements OnInit, OnDestroy {

  file: any;
  fileURL: any;

  @ViewChild("pdfViewer") pdfViewer: ElementRef;

  constructor(
    protected sanitizer: DomSanitizer,
    private apiUrl: ApiFactoryEndPoints,
    public dialogRef: MatDialogRef<InvoicePreviewComponent>,
    private productOrderSummaryService: ProductOrderSummaryServiceService,
    @Inject(MAT_DIALOG_DATA) public previewValue: string[]
  ) {
    this.productOrderSummaryService.getWebOrderInvoiceDetails(this.apiUrl.getWebOrderInvoiceDetails, previewValue[2], previewValue[1], previewValue[0], previewValue[3])
      .subscribe(
        (response) => {
          console.log(response);
          let file = new Blob([response], { type: "application/pdf" });
          this.fileURL = URL.createObjectURL(file);
          console.log(this.fileURL);
          this.pdfViewer.nativeElement.data =
            this.fileURL + "#toolbar=0&navpanes=0&scrollbar=0#zoom=page-width";
          // previewValue=fileURL
        },
        (e) => {
          throwError(e);
          console.log(e);
        }
      );
    dialogRef.disableClose = true;
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {

  }

  downloadPdf() {
    let content = this.pdfViewer.nativeElement.data;
    fileSaver.saveAs(content, this.previewValue[1] + ".pdf");

  }

  print() {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = this.sanitizer.sanitize(
      SecurityContext.RESOURCE_URL,
      this.sanitizer.bypassSecurityTrustResourceUrl(this.fileURL)
    );
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
}